/** @module wgfractals/util/f64 */

// JS numbers are already f64, so splitting one into a double-double (hi, lo)
// f32 pair for the GPU (see src/shaders/f64/dekker.wgsl's DD struct) is just:
// round to the nearest f32 (hi), then capture what that rounding lost (lo).
// hi+lo together carry ~48 bits of mantissa — shy of the f64 input's 52, but
// far past plain f32's 24, which is the whole point of f64Variant formulas.

/**
 * @param {number} x
 * @returns {{hi: number, lo: number}}
 */
export function splitDD(x) {
  const hi = Math.fround(x);
  const lo = Math.fround(x - hi);
  return { hi, lo };
}
